import { render, staticRenderFns } from "./CProfileDisplay.vue?vue&type=template&id=ca073328&"
import script from "./CProfileDisplay.vue?vue&type=script&lang=js&"
export * from "./CProfileDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports